import { useStateStore } from "@/context/stateStore";
import { INote } from "@/models/types/note";
import { apiRequest, hasBaseUrl, hasEmail } from "../helpers/apiClient";

export async function CreateNote({ note, user, urlToUse }: { note: INote, user: string, urlToUse: string }) {

    if (!note) {
        return { status: false, message: "Note is required" };
    }

    if (!hasEmail(user)) {
        return { status: false, message: "User email is required" };
    }

    if (!hasBaseUrl(urlToUse)) {
        return { status: false, message: "Base URL is not set" };
    }

    const result = await apiRequest<{ newNotes: INote[] }>({
        url: `${urlToUse}/api/note/create`,
        method: 'POST',
        body: { noteToCreate: note, email: user },
        failureMessage: 'Error creating note',
    });

    if (!result.success || !result.data) {
        return { status: false, message: result.message };
    }

        const data = result.data;
        const newNoteGroup = [...data.newNotes] as INote[];
        if (!newNoteGroup) {
            return { status: false, message: "Invalid note data returned" };
        }

        useStateStore.getState().setNotes(newNoteGroup);
        return { status: true, message: "Note created successfully" };
}
